module.exports = __webpack_public_path__ + "assets/async.c2666df5.svg";